// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604091403/js/" + chunkId + "." + {"44":"5291701d","225":"6100f5e8","481":"71fde355","486":"e91a5fb1","770":"5bbbb05b"}[chunkId] + ".0.7040671055177183.chunk.js";
};